import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { makeStyles, Box, Hidden, Button } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/styles'

import theme from 'theme'
import JssProvider from 'react-jss/lib/JssProvider'
import { createGenerateClassName } from '@material-ui/core/styles'

import { TopBar, NavBar, MenuBar } from './components'
import SnackbarProvider from 'providers/SnackbarProvider'
import * as service from 'service'

import styles from './styles'
import checkoutTheme from 'theme/themeLeadLovers'

const useStyles = makeStyles(styles)

const defaultGenerateClassName = createGenerateClassName({
  disableGlobal: true,
  productionPrefix: 'c',
})

const Main = ({ children }) => {
  const classes = useStyles()
  const [isMobileNavOpen, setMobileNavOpen] = useState(false)
  const [auth, setAuth] = useState(false)
  const [selectedTheme, setSelectedTheme] = useState(null)
  const [showButton, setShowButton] = useState(false)
  const [logo, setLogo] = useState(null)

  const defaultInputsCheckout = {
    name: 'Default Template',
    author: 'Superfin',
    urlImage:
      'https://lps.leadlovers.com/_next/image?url=%2Fimg%2Flogo-leadlovers.webp&w=256&q=100',
    version: '1.0.0',
    settings: {
      theme: [checkoutTheme],
      inputs: [],
    },
  }

  const postTheme = async () => {
    try {
      await service.intermediador.accountCustomizations.create({
        tag: 'portal_theme',
        data: JSON.stringify(defaultInputsCheckout),
      })
    } catch (error) {
      return null
    }
  }

  const getTheme = async (token) => {
    if (token) {
      try {
        const response = await service.intermediador.accountCustomizations.show(
          'portal_theme',
          token?.id,
        )
        const themeData = JSON.parse(response?.data.accountCustomization?.data)

        const newTheme = {
          ...themeData?.settings?.theme[0],
          breakpoints: {
            ...theme?.breakpoints,
          },
          palette: {
            ...themeData?.settings?.theme[0]?.palette,
            getContrastText: theme?.palette?.getContrastText,
          },
          typography: {
            ...themeData?.settings?.theme[0]?.typography,
            pxToRem: theme?.typography?.pxToRem,
            round: theme?.typography.round,
          },
          transitions: theme?.transitions,
          spacing: theme?.spacing,
        }
        setLogo(themeData?.urlImage)
        setSelectedTheme(newTheme)
        return null
      } catch (error) {
        setSelectedTheme(theme)
        return null
      }
    } else {
      console.log(' ')
    }
  }

  const toggleButton = useCallback(() => {
    setShowButton((prevShowButton) => !prevShowButton)
  }, [])

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === 'm') {
        toggleButton()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [toggleButton])

  // Fetch user on mount
  useEffect(() => {
    const getResponse = async () => {
      try {
        const response = await service.intermediador.users.me()
        await getTheme(response?.data?.user?.account)
        setAuth(response?.data?.user)
      } catch (error) {
        return null
      } finally {
        return null
      }
    }
    getResponse()
  }, [])

  // Load theme when auth?.account changes
  useEffect(() => {
    const loadTheme = async () => {
      if (auth?.account) {
        await getTheme(auth.account)
      }
    }
    loadTheme()
  }, [auth?.account])

  const handleMobileClose = useCallback(() => {
    setMobileNavOpen(false)
  }, [])

  return (
    <>
      {selectedTheme && (
        <ThemeProvider theme={selectedTheme}>
          <JssProvider generateClassName={defaultGenerateClassName}>
            <SnackbarProvider>
              <Box className={classes.root}>
                <Hidden mdDown>
                  <Box display="flex" alignItems="center">
                    <NavBar
                      logo={logo}
                      onMobileClose={handleMobileClose}
                      openMobile={isMobileNavOpen}
                    />
                  </Box>
                </Hidden>
                <Box className={classes.wrapper}>
                  <Box className={classes.contentContainer}>
                    <Box className={classes.content}>
                      <TopBar
                        // logo={authValue?.account?.partnerGroup}
                        onMobileNavOpen={() => setMobileNavOpen(true)}
                      />
                      {showButton && (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={postTheme}
                        >
                          Subir
                        </Button>
                      )}
                      {children}
                      <Hidden lgUp>
                        <Box pb={10}></Box>
                        <Box className={classes.menuBottom}>
                          <MenuBar />
                        </Box>
                      </Hidden>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </SnackbarProvider>
          </JssProvider>
        </ThemeProvider>
      )}
    </>
  )
}

Main.propTypes = {
  children: PropTypes.any,
}

export default Main
